import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, DropdownButton, ButtonGroup } from 'react-bootstrap';
import classNames from 'classnames';
import { connect } from 'react-redux';
import toastr from '../toastr';
import MaterialSearch from '../MaterialSearch';
import FormHelperBarcodeScanner from '../form/helpers/FormHelperBarcodeScanner';

class ListViewToolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      count: 0,
      refreshing: false,
      terms: props.terms,
    };
  }

  setCount(count) {
    this.setState({ count });
  }

  handleChange = e => {
    const { value } = e.target;
    this.setState({ terms: value });
    this.props.handleSearch(value);
  };

  refresh = () => {
    this.setState({ refreshing: true });

    this.props
      .handleRefresh()
      .then(() => {
        toastr.success('Refresh Complete');
      })
      .catch(() => {
        toastr.error('Error during refresh');
      })
      .finally(() => {
        this.setState({ refreshing: false });
      });
  };

  renderRefreshButton() {
    const { refreshing } = this.state;

    const title = refreshing ? 'Refreshing' : 'Refresh';
    const disabled = refreshing;
    const classes = classNames('fas', 'fa-sync', {
      'fa-spin': refreshing,
    });

    return (
      <Button
        variant="secondary"
        title={title}
        onClick={this.refresh}
        className="list-refresh-button"
        disabled={disabled}
      >
        <i className={classes} />
      </Button>
    );
  }

  renderOptionsButton() {
    const {
      canExport,
      customOptions,
      handleClearFilters,
      handleExport,
      handleLoadLayout,
      handleRemoveLayout,
      handleSaveLayout,
      handleThemeChange,
      handleToggleVerticalHeaders,
      layout,
    } = this.props;

    const renderCustomOptions = () => {
      if (!customOptions || !customOptions.length) {
        return null;
      }

      return (
        <>
          <Dropdown.Divider />
          {customOptions.map((option, i) => {
            return (
              <Dropdown.Item key={i} onClick={option.onClick}>
                {option.label}
              </Dropdown.Item>
            );
          })}
        </>
      );
    };

    const optionsTitle = (
      <div>
        <i className="fa fa-cog" /> <span className="d-none d-lg-inline">Options</span>
      </div>
    );

    return (
      <DropdownButton
        as={ButtonGroup}
        variant="secondary"
        id="list-layout-dropdown"
        title={optionsTitle}
        className="no-caret"
        alignRight
      >
        {canExport && (
          <>
            <Dropdown.Header>Export</Dropdown.Header>
            <Dropdown.Item eventKey="3" onClick={handleExport}>
              Download CSV
            </Dropdown.Item>
            <Dropdown.Divider />
          </>
        )}
        <Dropdown.Header id="layout-menu-header">Layout {!!layout && <span>({layout.name})</span>}</Dropdown.Header>
        <Dropdown.Item
          eventKey="4"
          onClick={() => {
            this.setState({ terms: '' });
            handleClearFilters();
          }}
        >
          Clear Filters
        </Dropdown.Item>
        <Dropdown.Item eventKey="4" onClick={handleToggleVerticalHeaders}>
          Toggle Vertical Headers
        </Dropdown.Item>
        <Dropdown.Item eventKey="5" onClick={handleLoadLayout}>
          Load Layout
        </Dropdown.Item>
        <Dropdown.Item eventKey="6" onClick={handleSaveLayout}>
          Save Layout
        </Dropdown.Item>
        {!!layout && (
          <Dropdown.Item eventKey="7" onClick={handleRemoveLayout}>
            Delete Layout
          </Dropdown.Item>
        )}
        <Dropdown.Header>Style</Dropdown.Header>
        <Dropdown.Item
          eventKey="8"
          onClick={() => handleThemeChange('comfort')}
          active={this.props.theme === 'comfort'}
        >
          Comfort
        </Dropdown.Item>
        <Dropdown.Item
          eventKey="9"
          onClick={() => handleThemeChange('compact')}
          active={this.props.theme === 'compact'}
        >
          Compact
        </Dropdown.Item>
        {renderCustomOptions()}
      </DropdownButton>
    );
  }

  renderFilterButton() {
    const { handleFilter } = this.props;

    if (!handleFilter) {
      return null;
    }

    return (
      <Button title="Filter" onClick={this.props.handleFilter} variant="secondary">
        <i className="fas fa-filter" /> <span className="d-none d-lg-inline">Filter</span>
      </Button>
    );
  }

  renderAddButton() {
    const { canAdd } = this.props;

    if (!canAdd) {
      return null;
    }

    const title = 'Add New';

    return (
      <>
        <Button variant="success" title={title} onClick={this.props.handleAddNew} className="list-add-button lg">
          <i className="fas fa-plus-circle" /> Add New
        </Button>
        <Button variant="success" title={title} onClick={this.props.handleAddNew} className="list-add-button sm">
          <i className="fas fa-plus-circle" />
        </Button>
      </>
    );
  }

  renderBarcodeButton() {
    if (!_.get(this.props.page, 'data.page.List.barcodes')) {
      return;
    }

    const handleScan = value => {
      this.setState({ terms: value });
      this.props.handleSearch(value);
    };

    return (
      <FormHelperBarcodeScanner setValue={handleScan} className="list-add-button" fullscreen={false} size={null} />
    );
  }

  render() {
    return (
      <div id="list-toolbar-wrapper">
        <div id="list-toolbar">
          {this.props.hasFilter && (
            <div className="filter-indicator" title="Filter Present">
              <i className="fas fa-list" />
              <i className="fas fa-filter fa-border over" />
            </div>
          )}
          <MaterialSearch
            onChange={this.handleChange}
            loading={this.props.loading}
            results={this.state.count}
            value={this.state.terms}
            onClear={() => {
              this.setState({ terms: '' });
              this.props.onClear();
            }}
            clearLeft
            autoFocus
          />
          <div className="list-toolbar-items">
            <ButtonGroup>
              {this.renderBarcodeButton()}
              {this.renderRefreshButton()}
              {this.renderFilterButton()}
              {this.renderOptionsButton()}
              {this.renderAddButton()}
            </ButtonGroup>
          </div>
        </div>
      </div>
    );
  }
}

ListViewToolbar.defaultProps = {
  canAdd: true,
  canExport: true,
  loading: false,
  terms: '',
  customOptions: [],
};

ListViewToolbar.propTypes = {
  canAdd: PropTypes.bool,
  canExport: PropTypes.bool,
  customOptions: PropTypes.array,
  handleAddNew: PropTypes.func,
  handleClearFilters: PropTypes.func,
  handleExport: PropTypes.func,
  handleFilter: PropTypes.func,
  handleLoadLayout: PropTypes.func,
  handleRefresh: PropTypes.func,
  handleRemoveLayout: PropTypes.func,
  handleSaveLayout: PropTypes.func,
  handleSearch: PropTypes.func,
  handleThemeChange: PropTypes.func,
  handleToggleVerticalHeaders: PropTypes.func,
  layout: PropTypes.object,
  loading: PropTypes.bool,
  page: PropTypes.object,
  terms: PropTypes.string,
  theme: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    page: state.page,
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(ListViewToolbar);
